import {useEffect, useState} from 'react'
import Modal from 'react-modal'
import MainBanner from '@/layouts/BookRideView/mainBanner.jsx'
import DestinationBanner from '@/layouts/BookRideView/destinationBanner.jsx'
import {HopnReviewsWidget} from '@/customComponents/BookRideSteps/Components/hopnReviewsWidget.jsx'
import {storage, STORAGE_KEYS} from '@/utils/storage'

// Google Maps script is loaded globally in index.html, so no <LoadScript> here.

// react-modal needs to know the app element for accessibility
if (typeof document !== 'undefined' && document.getElementById('root')) {
    Modal.setAppElement('#root')
}

const hasStoredPickup = () => {
    const saved = storage.get(STORAGE_KEYS.DESTINATIONS, [])
    return Array.isArray(saved) && !!saved[0]?.address
}

export default function BookRide() {
    // Single /book-ride route — swap MainBanner ↔ DestinationBanner in place so
    // HopnReviewsWidget (and any other layout-level UI) doesn't unmount/reload
    // when the user picks a pickup location.
    const [view, setView] = useState(() => (hasStoredPickup() ? 'destination' : 'main'))

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'instant'})
    }, [])

    return (
        <div className="hopn-book-ride">
            {view === 'main' ? (
                <MainBanner
                    bannerConfig={{
                        titleDesktop: 'Toronto Airport Limo & Taxi Service',
                        titleMobile: 'Airport rides made simple',
                    }}
                    onAdvance={() => setView('destination')}
                />
            ) : (
                <DestinationBanner onBackToMain={() => setView('main')}/>
            )}
            <HopnReviewsWidget/>
        </div>
    )
}
